export default __webpack_public_path__ + "static/media/bizz.0e28c302.PNG";